var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header ticker"},_vm._l((_vm.textArray),function(label,indexT){return _c('labelc',{key:label,attrs:{"type":"ticker","text":label}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }